export default {
  deleteReview: 'Delete review',
  deleteReviewConfirm: 'Are you sure you want to delete this review?'
}



// WEBPACK FOOTER //
// ./src/i18n/en/routes/reviews.js